import { Table } from "reactstrap";
import { applyClassToCharacters } from "../../../../constants/const";
import { GetLanguageString, NoResult } from "../../../helper/Components";
import { GetSelectedLanguage } from "../../../helper/Method";

const formatAmount = (value) =>
  new Intl.NumberFormat().format(Number(value) || 0);

const headerStyle = {
  background: "linear-gradient(180deg, #f7fafc 0%, #eef3f7 100%)",
  color: "#2D4455",
  fontWeight: 700,
  fontSize: "12px",
  letterSpacing: "0.2px",
  borderBottom: "2px solid #d7e2ea",
  whiteSpace: "nowrap",
  position: "sticky",
  top: 0,
  zIndex: 1,
};

const exceedStyle = (row) => {
  if (!row?.exceedsLimit) {
    return {};
  }
  if (row.exceedReason === "cash_limit") {
    return { background: "#fdecea" };
  }
  return { background: "#fff4e5" };
};

const CashBalanceReportTable = ({ rows }) => {
  if (!rows || rows.length === 0) {
    return <NoResult />;
  }

  const headerUrClass = GetSelectedLanguage() === "ur" ? "ur" : "";

  return (
    <div
      style={{
        border: "1px solid #e4edf3",
        borderRadius: "12px",
        overflow: "auto",
        boxShadow: "0 4px 16px rgba(45, 68, 85, 0.06)",
      }}
    >
      <Table responsive className="mb-0" style={{ marginBottom: 0 }}>
        <thead>
          <tr>
            <th className={`text-center ${headerUrClass}`} style={headerStyle}>
              <GetLanguageString props="cash_balance_report_sr_no" />
            </th>
            <th className={`text-center ${headerUrClass}`} style={headerStyle}>
              <GetLanguageString props="cash_balance_report_unit" />
            </th>
            <th className={`text-center ${headerUrClass}`} style={headerStyle}>
              <GetLanguageString props="cash_balance_report_parent" />
            </th>
            <th className={`text-center ${headerUrClass}`} style={headerStyle}>
              <GetLanguageString props="cash_balance_report_cash" />
            </th>
            <th className={`text-center ${headerUrClass}`} style={headerStyle}>
              <GetLanguageString props="cash_balance_report_amanat" />
            </th>
          </tr>
        </thead>
        <tbody>
          {rows.map((row, index) => (
            <tr
              key={`${row.unitId}-${row.srNo}-${index}`}
              style={{
                ...exceedStyle(row),
                borderBottom: "1px solid #eef3f7",
              }}
            >
              <td className="text-center" style={{ verticalAlign: "middle" }}>
                {row.srNo}
              </td>
              <td className="text-center" style={{ verticalAlign: "middle" }}>
                {applyClassToCharacters(row.unitName, "ur")}
              </td>
              <td className="text-center" style={{ verticalAlign: "middle" }}>
                {applyClassToCharacters(row.parentPath, "ur")}
              </td>
              <td className="text-center" style={{ verticalAlign: "middle" }}>
                {row.cashInHand == null ? "—" : formatAmount(row.cashInHand)}
              </td>
              <td className="text-center" style={{ verticalAlign: "middle" }}>
                {row.amanatNotApplicable ? (
                  <GetLanguageString props="cash_balance_report_amanat_na" />
                ) : row.amanatBalance == null ? (
                  "—"
                ) : (
                  formatAmount(row.amanatBalance)
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
    </div>
  );
};

export default CashBalanceReportTable;
